<div class="card">
    <img [src]="'./assets/images/logos/' + logo" class="card-img-top mt-1" alt="Logo">
    <div class="card-body">
      <h5 class="card-title">{{'SHIPMENTLABELS'|translate}}</h5>
      <p class="card-text">{{articleCount}} {{(articleCount === 1 ? 'ARTICLE' : 'ARTICLES') |translate}}<ng-content select="[article-details]"></ng-content></p>
      <ng-content></ng-content>
    </div>
  </div>
